function addFormAddressRules(formSelector) {
    const $form = $(formSelector);

    if (!$form.length) {
        return false;
    }

    const formRules = $form.validate().settings.rules,
        addressRules = {
            addressNumber: {
                addressNumber: true
            }
        };

    if (formSelector === '.js-form-reg') {
        formRules.billing_address = addressRules.addressNumber;
        formRules.shipping_address = addressRules.addressNumber;
        formRules.address = addressRules.addressNumber;
    }

    $form.find('[name*="customer_addresses"]').each(function() {
        if (/customer_addresses.*address/.exec(this.name) !== null) {
            formRules[this.name] = addressRules.addressNumber;
        }
    });
}

function checkPostCodeType(firstTime = false) {
    $('[name*="country_id"]').each(function(){
        const $select = $(this).closest('.l-row').find('.js-post-code-select');

        if ($(this).val() == 190) {
            $select.removeClass('hidden');
        } else {
            $select.addClass('hidden');
        }
    });
}

// Skaredy ojeb, nefungovalo mi to inak bohuial a uz som nechcel stracat cas
function turnOffAutocompleteForAddresses() {
    const inputsToTurnOffAutocomplete = [
        $('[name="address"]'),
        $('[name="city"]'),
        $('[name="post_code"]'),
        $('[name="billing_address"]'),
        $('[name="billing_city"]'),
        $('[name="billing_post_code"]'),
        $('[name="shipping_address"]'),
        $('[name="shipping_city"]'),
        $('[name="shipping_post_code"]'),
    ]

    $('[name^="customer_addresses"]').each(function() {
        const inputName = $(this).attr('name').replace('customer_addresses', '')

        if (
            inputName.indexOf('address') !== -1
            || inputName.indexOf('city') !== -1
            || inputName.indexOf('post_code') !== -1
        ) {
            inputsToTurnOffAutocomplete.push($(this))
        }
    });

    for (const input of inputsToTurnOffAutocomplete) {
        const randomString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
        input.attr('autocomplete', randomString)
    }
}

$(function() {
    // checkPostCodeType(true);

    // $('[name*="country_id"]').on('change', function() {
    //     checkPostCodeType();
    // });

    window.cityInputTimeouts = {}
    document.querySelectorAll('.js-city-input').forEach(function(cityInputEl, index) {
        const inputIdentifier = cityInputEl.dataset.identifier;
        const stateInputEl = document.querySelector(
            `.js-state-input[data-identifier="${inputIdentifier}"]`
        )

        if (!stateInputEl) {
            return
        }

        // jquery event, because of jquery autocomplete
        $(cityInputEl).on('change blur', function() {
            stateInputEl.value = ''
            cityInputEl.classList.add('is-loading')

            if (document.querySelector('.js-shopping-form-submit')) {
                document.querySelector('.js-shopping-form-submit').disabled = true
            }

            const $errorMessage = $(`.js-state-input-error[data-identifier="${inputIdentifier}"]`)

            if ($errorMessage.length) {
                $errorMessage.remove()
            }

            $.ajax({
                url: '/get-state-id',
                type: 'post',
                dataType: "json",
                data: {
                    city: cityInputEl.value
                },
                success: function(response) {
                    stateInputEl.value = response.state_id
                },
                error: function(xhr, status, error) {
                    console.error(error)
                },
                complete: function() {
                    cityInputEl.classList.remove('is-loading')

                    if (document.querySelector('.js-shopping-form-submit')) {
                        document.querySelector('.js-shopping-form-submit').disabled = false
                    }
                }
            })
        })

        setTimeout(() => {
            const closestValidator = $(stateInputEl).closest('form').data('validator')
            closestValidator.settings.rules[stateInputEl.name] = {
                required: function() {
                    return !!cityInputEl.value && $(cityInputEl).valid()
                },
            }
            closestValidator.settings.messages[stateInputEl.name] = {
                required: stateInputEl.dataset.requiredMessage,
            }
        }, 100)
    });

    $('.js-multiselect').each(function () {
        const $multiselect = $(this);
        const enableFiltering = true;
        const options = {
            templates: {
                button: `
                    <button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown">
                        <span class="multiselect-selected-text"></span>
                        <i aria-hidden="true" class="ico ico-chevron-down"></i>
                    </button>
                `,
                filter: `
                    <li class="multiselect-item filter">
                        <div class="input-group">
                            <input class="c-form__input is-sm multiselect-search" type="text">
                        </div>
                    </li>
                `,
                filterClearBtn: ''
            },
            buttonClass: 'c-btn',
            enableHTML: true,
            enableCaseInsensitiveFiltering: enableFiltering,
            filterBehavior: 'text',
            /*buttonText: function (options, select) {
                var labels = [];
                options.each(function () {
                    labels.push($(this).text().replace(/(<[^>].*<\/.*>)/ig, ''))
                });
                return labels.join(' - ');
            },
            buttonTitle: function (options, select) {
                var labels = [];
                options.each(function () {
                    labels.push($(this).text().replace(/(<[^>].*<\/.*>)/ig, ''))
                });
                return labels.join(' - ');
            },*/
            onDropdownShown: function(event) {
                const searchInput = event.target.querySelector('input.multiselect-search')

                if (searchInput) {
                    searchInput.focus()
                }
            }
        };

        $multiselect.not('.is-loaded').multiselect(options);
        $multiselect.addClass('is-loaded');
    });

    if (window.foxentryUsed) {
        setInterval(() => {
            turnOffAutocompleteForAddresses()
        }, 1000);
    }

    requestAnimationFrame(function() {
        addFormAddressRules('.js-form-reg');
        addFormAddressRules('.js-account-addresses');
        addFormAddressRules('.js-account-addresses-modal');
    });
});

